import type { ItemType } from "@shared/graphql.types";

export const isFreeItem = (item?: ItemType): boolean =>
  item?.origin === "discount";
